'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

require('../../../primitives/Button/Button.js');

require('../../../primitives/Hero/Hero.js');

var Icon = require('../../../primitives/Icon/Icon.js');

require('../../../primitives/Link/Link.js');

var ContentBody = require('../../ContentBody/ContentBody.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var AccordionItem = function AccordionItem(_ref) {
  var title = _ref.title,
      content = _ref.content;

  var _useState = React.useState(false),
      _useState2 = slicedToArray['default'](_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var contentClasses = index['default']('lanl-accordion-item-content', isOpen && 'open');
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "lanl-accordion-item"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    className: "lanl-accordion-item-button",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, title, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
    icon: "chevron-".concat(isOpen ? 'up' : 'down'),
    size: "sm",
    className: "lanl-accordion-item-button-icon"
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    "data-testid": "lanl-accordion-item-content",
    className: contentClasses
  }, /*#__PURE__*/React__default['default'].createElement(ContentBody.ContentBody, {
    isHTML: true,
    body: content
  })));
};

AccordionItem.defaultProps = {
  title: '',
  content: ''
};
AccordionItem.propTypes = {
  content: PropTypes__default['default'].string.isRequired,
  title: PropTypes__default['default'].string.isRequired
};
exports.AccordionItem = AccordionItem;
exports['default'] = AccordionItem;